import { useSelector } from "react-redux";
import { PageBreadcrumb } from "store/slices/appLayout";
import { RootState } from "store/store";

export const usePageBreadcrumbValue = (): PageBreadcrumb | null =>
  useSelector((state: RootState) => state.appLayout.breadcrumb);
